<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div class="root-nav" [ngClass]="{'hide-root-nav': !(shouldShowNav$ | async) }">
    <div fxHide.xs fxShow>
        <div fxLayout="row" fxLayoutAlign="space-between start">
            <nav mat-tab-nav-bar class="root-nav mat-elevation-z2">
                <ng-container *ngIf="(menuBarImage$ | async) as menuBarImage">
                    <img id="menu-bar-image" class="menu-bar-image" [src]="menuBarImage.src" [alt]="menuBarImage.altText" />
                </ng-container>
                <a mat-tab-link
                   *ngIf="pageEnabled$('dashboard') | async"
                   routerLink="/dashboard"
                   routerLinkActive #dashboardActive="routerLinkActive"
                   [active]="dashboardActive.isActive"
                   name="dashboard">Dashboard</a>
                <a mat-tab-link
                   *ngIf="pageEnabled$('map') | async"
                   routerLink="/map"
                   routerLinkActive #mapActive="routerLinkActive"
                   [active]="mapActive.isActive"
                   name="map">Map</a>
                <a mat-tab-link
                   *ngIf="pageEnabled$('admin') | async"
                   routerLink="/admin"
                   routerLinkActive #adminActive="routerLinkActive"
                   [active]="adminActive.isActive"
                   name="admin">Admin</a>
                <div class="right-nav-controls" fxLayout='row' fxLayoutAlign='start center'>
                    <dash-gis-theme-switcher class="mat-tab-link icon-only"></dash-gis-theme-switcher>
                    <dash-gis-user-tools class="mat-tab-link" [showUsername]="true"></dash-gis-user-tools>
                </div>
            </nav>
        </div>
    </div>
    <div fxShow.xs fxHide="true">
        <div fxLayout="row" fxLayoutAlign="space-between start">
            <nav mat-tab-nav-bar class="root-nav mat-elevation-z2">
                <a mat-tab-link
                   *ngIf="pageEnabled$('dashboard') | async"
                   routerLink="/dashboard"
                   routerLinkActive #dashboardActive="routerLinkActive"
                   [active]="dashboardActive.isActive"
                   name="dashboard">Dashboard</a>
                <a mat-tab-link
                   *ngIf="pageEnabled$('map') | async"
                   routerLink="/map"
                   routerLinkActive #mapActive="routerLinkActive"
                   [active]="mapActive.isActive"
                   name="map">Map</a>
                <a mat-tab-link
                   *ngIf="pageEnabled$('admin') | async"
                   routerLink="/admin"
                   routerLinkActive #adminActive="routerLinkActive"
                   [active]="adminActive.isActive"
                   name="admin">Admin</a>
                <div class="right-nav-controls">
                    <dash-gis-theme-switcher class="mat-tab-link icon-only"></dash-gis-theme-switcher>
                    <dash-gis-user-tools class="mat-tab-link icon-only" [showUsername]="false"></dash-gis-user-tools>
                </div>
            </nav>
        </div>
    </div>
    <div class="dash-gis-main-content">
        <router-outlet></router-outlet>
    </div>
    <div style='display:none'>
        <table mat-table [dataSource]='dummyData'>
            <ng-container matColumnDef='a'>
                <th mat-header-cell *matHeaderCellDef>A</th>
                <td mat-cell *matCellDef='let element'>{{element.a}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef='["a"]'>A</tr>
            <tr mat-row *matRowDef='let row; columns: ["a"];'></tr>
        </table>
    </div>
</div>
